import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductParameterTypeState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductParameterTypeQuery extends QueryEntity<ProductParameterTypeState> {

  constructor(protected store: Store) {
    super(store);
  }

}
